// Hero.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import heroVideo from '../assets/hero_video.mp4';

const Hero = () => {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div 
            className="text-left"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <motion.h1 
              className="text-4xl md:text-5xl lg:text-5xl font-inter font-bold text-acBlack leading-tight"
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 1, delay: 0.3 }}
            >
              Validate Systems <br/> <span className="text-2xl font-semibold">Human-Verified Trust & Mobility</span>
            </motion.h1>
            
            <motion.p 
              className="text-lg text-gray-600 mt-6 max-w-2xl"
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 1, delay: 0.5 }}
            >
              We run person-to-person verification and organize immigration & travel documents so decisions are made on facts, not guesses.
            </motion.p>
            
            <motion.div 
              className="mt-8 flex flex-col sm:flex-row items-start gap-4"
              initial={{ opacity: 0, scale: 0.8 }} 
              animate={{ opacity: 1, scale: 1 }} 
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <Link 
                to="/verification" 
                className="bg-acYellow hover:bg-yellow-400 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
              >
                Request a Verification
              </Link>
              <Link 
                to="/travel" 
                className="bg-acBlack hover:bg-gray-800 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
              >
                Book a Travel Consult
              </Link>
            </motion.div>
            
            <motion.p 
              className="text-sm text-gray-500 mt-6"
              initial={{ opacity: 0, y: 10 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, delay: 1 }}
            >
              Serving Zimbabwe, Kenya Nigeria, Ghana, and South Africa.
            </motion.p>
          </motion.div>

          {/* Right Video */}
          <motion.div 
            className="relative"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <video
              className="w-full h-auto"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={heroVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
